import React from 'react';
import CustomPaginationActionsTable from '../TableList/TableList';

function CustomTable(props) {
    const { columns, data, onclick } = props;

    const handleClick = (event, row) => {
        const _row = {
            ...row,
            tableData: {
                id: row._index,
            },
        };
        onclick(event, _row);
    };

    return (
        <div style={{ overflow: 'auto' }}>
            <CustomPaginationActionsTable
                columns={columns}
                hideFilterOrder={true}
                hideHeader={true}
                hidePagination={true}
                rows={data}
                placeholderSearch="Busca"
                onChangePage={() => ({})}
                onChangeRowsPerPage={() => ({})}
                hideOrder={true}
                hideItemOrder={true}
                hideInitialDate={true}
                hideFinalDate={true}
                onClickRow={handleClick}
            />
        </div>
    );
}

export default CustomTable;
